import { c as _c } from "react/compiler-runtime";
/**
 * PageHero Component
 *
 * The main hero section for CMS pages. Displays a large title,
 * description text, and optionally a sidebar (like RelatedBox).
 *
 * @example
 * <PageHero
 *   title="Desktop VMS - Viewstation"
 *   description="View multiple NVRs or even multiple locations..."
 * >
 *   <RelatedBox links={[...]} />
 * </PageHero>
 */

import { cn } from '@/lib/utils';
interface PageHeroProps {
  /** Large page title */
  title: string;
  /** Description text - can be string or React node */
  description?: string | React.ReactNode;
  /** Optional sidebar content (e.g., RelatedBox) */
  children?: React.ReactNode;
  /** Additional CSS classes */
  className?: string;
}
export function PageHero(t0) {
  const $ = _c(24);
  const {
    title,
    description,
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("py-8 md:py-12 lg:py-16", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = children && "lg:flex-row lg:gap-12";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("flex flex-col gap-8", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = children ? "lg:w-2/3" : "lg:w-full";
  let t5;
  if ($[4] !== t4) {
    t5 = cn(t4);
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      color: "var(--scw-navy)"
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== title) {
    t7 = <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-6" style={t6}>{title}</h1>;
    $[7] = title;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== description) {
    t8 = description && <div className="text-base md:text-lg leading-relaxed" style={{
      color: "var(--scw-gray-body)"
    }}>{typeof description === "string" ? <p>{description}</p> : description}</div>;
    $[9] = description;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t5 || $[12] !== t7 || $[13] !== t8) {
    t9 = <div className={t5}>{t7}{t8}</div>;
    $[11] = t5;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== children) {
    t10 = children && <div className="lg:w-1/3 flex-shrink-0">{children}</div>;
    $[15] = children;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t3 || $[19] !== t9) {
    t11 = <div className="page-container"><div className={t3}>{t9}{t10}</div></div>;
    $[17] = t10;
    $[18] = t3;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t1 || $[22] !== t11) {
    t12 = <section className={t1}>{t11}</section>;
    $[21] = t1;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
}